import {NgModule} from '@angular/core';
import {PageNotFoundComponent} from './index';

@NgModule({
  imports: [],
  declarations: [PageNotFoundComponent],
  exports: [PageNotFoundComponent],
})
export class PageNotFoundModule {}
